export default {
    name: 'mapViewerFooterControls',
    data: function () {
        return {
            isLiked: false,
        };
    },
    props: {
        isAtlasMode: { type: Boolean },
        isEnabled: { type: Boolean },
        isInIframe: { type: Boolean },
    },
    methods: {
		inDevelopment: function() {

			return process.env.NODE_ENV !== "production";

		},
		mapReload: function() {
			this.$emit("reloadMap")
		},
		deleteMap: function() {
			this.$emit("deleteMap")
		},
        mapInfo: function () {
            if (this.isEnabled) {this.$emit('mapInfo');}
        },
        likeMap: function () {
            if (this.isEnabled && !this.isLiked) {
                this.$emit('likeMap');
                this.isLiked = true;
                /*
                var self = this;
                setTimeout(function () {
                    self.isLiked = false;
                }, 1000);
                */
            }
        },
        locate: function () {
            if (this.isEnabled) {this.$emit('locate');}
        },
        home: function () {
            if (this.isEnabled) {this.$emit('home');}
        },
        share: function () {
            if (this.isEnabled) {this.$emit('share');}
        },
        launch: function () {
            if (this.isEnabled) {this.$emit('launch');}
        },
        deleteLocate: function(){
            if (this.isEnabled) {this.$emit('deleteLocate');}
        }
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/footer-controls/footer-controls.js